<div id="nav-execution-list-dd" class="dropdown h-100">
  <!-- button -->
  <button class="agr-nav-btn" data-bs-toggle="dropdown" ngbTooltip="{{ getTaskTooltip() | translate }}">
    <i class="fa fa-tasks"></i>
    @if (connectionStatus === 1 && activeExecutionsCount > 0) {
    <span id="execution-list-badge" class="animated" [ngClass]="{ bounceIn: activeExecutionsCount }">
      {{ activeExecutionsCount }}
    </span>
    } @if (connectionStatus !== 1) {
    <span id="notify-connection-badge" class="animated" class="animated">
      @if (connectionStatus === 2) {
      <i class="fa fa-exclamation-triangle"></i>
      } @if (connectionStatus !== 2) {
      <i class="fa fa-refresh fa-spin"></i>
      }
    </span>
    }
  </button>

  <!-- drop-down -->
  <div class="dropdown-menu dropdown-menu-right" (click)="stopEvent($event)">
    <div class="dropdown-header border-bottom pb-2">
      <!-- title and clear btn -->
      <div class="agr-mini-tools">
        <div class="amt-area">
          <div class="amt-title">
            <h6>{{ 'NAV_EXECUTION_LIST' | agrTranslate }}</h6>
          </div>
        </div>
        <div class="amt-area">
          <!-- Hide action notifications from other users Button -->
          <button
            id="nav-execution-hide-others"
            class="amt-btn nav-execution-btn"
            (click)="toggleActionsFromOtherUsers($event)"
            ngbTooltip="{{
              (state.showActionsFromOtherUsers ? 'HIDE_ACTIONS_FROM_OTHER_USERS' : 'SHOW_ACTIONS_FROM_OTHER_USERS') | agrTranslate
            }}">
            <i class="fa" [ngClass]="{ 'fa-bell': state.showActionsFromOtherUsers, 'fa-bell-slash': !state.showActionsFromOtherUsers }">
            </i>
          </button>
          <!-- Clear all of your notifications Button -->
          <button
            id="nav-execution-clear-all"
            class="amt-btn nav-execution-btn"
            [disabled]="userActionsCount === 0"
            (click)="clearAllUserActions($event)"
            ngbTooltip="{{ 'CLEAR' | agrTranslate }}">
            <i class="fa fa-ban"></i>
          </button>
        </div>
      </div>
    </div>

    <!-- execution list items -->
    @if (actions.length > 0) {
    <div id="execution-list-items" class="u-vh-80 u-overflow-y border-bottom">
      @for (action of actions; track action) {
      <button type="button" class="action-item dropdown-item border-bottom" routerLink="/{{ !!action.url ? action.url : 'executions' }}">
        <!-- header, action caption and name -->
        <div class="action-item-header">
          <strong>{{ action.type | agrTranslate }}</strong>
          <span class="action-item-from font-italic text-truncate" title="{{ action.caption | agrTranslate }}">
            : {{ action.caption | agrTranslate }}</span
          >
          <!-- Clear action button -->
          @if (action.userId === sessionService.user.id && action.progressPercent === 100) {
          <button type="button" class="agr-btn-close" (click)="clearAction(action.id, $event)">
            <i class="fa fa-close"></i>
          </button>
          }
        </div>
        <!-- loading bar-->
        @if (!action.progressPercent || action.progressPercent < 100) {
        <div id="action-item-loading-bar" class="progress">
          <div class="progress-bar progress-bar-striped progress-bar-animated w-100"></div>
        </div>
        }
        <!-- details  -->
        <div class="action-item-details">
          <span class="small"
            >{{ action.userId === 0 ? ('SCHEDULER' | agrTranslate) : action.userName }}, {{ action.createdAt | agrFromNow }}</span
          >
          @if (action.success) {
          <div
            class="badge bg-success pull-right mt-1"
            data-cy="execution-list-success-badge"
            ngbTooltip="{{ 'RUNNING_TIME' | agrTranslate }}: {{ action.duration | agrFormat: 'durationHuman' }}"
            placement="bottom"
            routerLink="/executions"
            (click)="stopEvent($event)">
            {{ 'DONE' | agrTranslate }}
          </div>
          } @if (action.success === false) {
          <div class="badge bg-danger pull-right me-1 mt-1" routerLink="/executions">{{ 'ERROR' | agrTranslate }}</div>
          }
        </div>
      </button>
      }
    </div>
    }

    <!-- no items message -->
    @if (actions.length === 0) {
    <div id="execution-list-no-items" class="dropdown-header border-bottom">{{ 'NAV_EXEC_NOTHING_TO_SHOW' | agrTranslate }}</div>
    }

    <!-- show more -->
    <button id="execution-list-show-more" type="button" class="dropdown-item mt-2" routerLink="/executions">
      {{ 'NAV_SHOW_MORE' | agrTranslate }}
    </button>
  </div>
</div>
